import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { ReactComponent as XCircleLight } from 'ui-components/src/images/monochrome-icons/x-circle-icon.svg';

import { ReactComponent as CheckCircle } from './../../../../images/icons/notifications/checkmark-circle.svg';
import { ReactComponent as ExclamationCircle } from './../../../../images/icons/notifications/exclamation-circle.svg';
import { ReactComponent as InfoCircle } from './../../../../images/icons/notifications/info-circle.svg';
import { ReactComponent as XCircle } from './../../../../images/icons/notifications/x-circle.svg';
import * as actions from "./../../../../actions";
import SlidingHeaderMenu from "../SlidingHeaderMenu";
import axios from "axios";

const NotificationMenu = ({setNotificationsViewed, notifications, triggerClass, isActive, closeTrigger, clearNotifications, deleteNotification, fetchNotifications, isAuthenticated}) => {
    useEffect(() => {
        if(isAuthenticated){
            fetchNotifications();
        }
    }, [isAuthenticated, fetchNotifications]);

    useEffect(() => {
        if(isActive){
            setNotificationsViewed(_.filter(notifications.data, { visibility: "new" }));
        }
    }, [isActive, notifications, setNotificationsViewed]);

    return <SlidingHeaderMenu className="right-side-menu" isActive={isActive} triggerClass={triggerClass} closeTrigger={closeTrigger} title="Notifications" ActionButton={() => {
        return <button className="delete-all-notifications-button" onClick={() => clearNotifications(notifications.data)}>Clear All</button>
    }} >
        <div className="notification-menu-content">
            {notifications.status === actions.STATUS_SUCCESS && notifications.data.length === 0 && <div className="no-notifications">No new notifications to display</div> }

            {_.get(notifications, 'notifications') && this.props.notifications.data.map(notification => (
                <Notification key={notification.createDate}
                              notification={notification}
                              onDelete={() => deleteNotification(notification)}
                />
            ))}
        </div>
    </SlidingHeaderMenu>
};

const mapDispatchToProps = dispatch => ({
        fetchNotifications: () => {
            const payload = axios.get("/portal/notifications");

            payload.then(r => dispatch({type: "NOTIFICATIONS:FETCH-SUCCESS", payload: r}));

            dispatch({
                type: "NOTIFICATIONS:FETCH"
            });

            return payload;
        },
        clearNotifications: notifications => {
            dispatch({
                type: "NOTIFICATIONS:CLEAR",
                payload: notifications
            });
        },
        deleteNotification: notification => {
            dispatch({
                type: "NOTIFICATIONS:DELETE",
                payload: notification
            });
        },
        setNotificationsViewed: notifications => {
            dispatch({
                type: "NOTIFICATIONS:SET-VIEWED",
                payload: notifications
            });
        }
    }
);

const mapStateToProps = state => ({
    auth: state.auth,
    notifications: state.notifications
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationMenu);

const Notification = props => <div className="notification-outer">
    <VerticalBar severity={props.notification.severity} visibility={props.notification.visibility} />
    <div className="notification-inner">
        <div className="notification-date-time">
            <NotificationIcon severity={props.notification.severity} />
            <span className="small-vertical-bar">|</span>
            <span className="notification-date">{getDate(props.notification.createDate)}</span>
            <span className="small-vertical-bar">|</span>
            <span className="notification-date">{getTime(props.notification.createDate)}</span>
            <button className="delete-notification-button" onClick={() => props.onDelete(props.notification)}><XCircleLight/> </button>
        </div>
        <div className="notification-title">
            {getTitle(props.notification.service)}
        </div>
        <div className="notification-message" dangerouslySetInnerHTML={{ __html: props.notification.message }} />
    </div>
</div>;

const VerticalBar = props => <div>
    {props.severity === "error" && <div className="vertical-bar-error"> </div>}
    {props.severity === "warning" && <div className="vertical-bar-warning"> </div>}
    {props.severity === "info" && <div className="vertical-bar-info"> </div>}
    {props.severity === "success" && <div className="vertical-bar-success"> </div>}
</div>;

const NotificationIcon = props => <div>
    {props.severity === "error" && <XCircle className="icon-error" />}
    {props.severity === "warning" && <ExclamationCircle className="icon-warning"/>}
    {props.severity === "info" && <InfoCircle className="icon-info"/>}
    {props.severity === "success" && <CheckCircle className="icon-success"/>}
</div>;

const getDate = createDate => {
    const date = new Date(createDate);
    return date.toLocaleDateString().replace(/\//g, ".");
};

const getTime = createDate => {
    const date = new Date(createDate);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

const getTitle = service => {
    if (service === 'ontap-cloud') return "Cloud Volumes ONTAP";
    return "NOTIFICATION";
};
